module.exports = __webpack_public_path__ + "static/media/mFudge.b9c12e82.jpeg";